export default __webpack_public_path__ + "img/Poppins-SemiBold_7cf883b.eot";